import LoginView from "@/views/LoginView.vue";
import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/admin/authStore";
import ConfigService from "@/services/admin/ConfigService";

// Lazy loading de todas as views (exceto Login que e a primeira tela)
const HomeView = () => import("@/views/HomeView.vue");
const DashboardMultiLojaView = () => import("@/views/DashboardMultiLojaView.vue");
const MeuPerfilView = () => import("@/views/MeuPerfilView.vue");
const LgpdView = () => import("@/views/LgpdView.vue");

// Loja
const CategoriaView = () => import("@/views/loja/CategoriaView.vue");
const ProdutoView = () => import("@/views/loja/ProdutoView.vue");
const EstoqueView = () => import("@/views/loja/EstoqueView.vue");
const CaixaView = () => import("@/views/loja/CaixaView.vue");
const ClienteView = () => import("@/views/loja/ClienteView.vue");
const VendaView = () => import("@/views/loja/VendaView.vue");
const ImportacaoView = () => import("@/views/loja/ImportacaoView.vue");
const RelatorioView = () => import("@/views/loja/RelatorioView.vue");
const FornecedorView = () => import("@/views/loja/FornecedorView.vue");
const TrocaView = () => import("@/views/loja/TrocaView.vue");
const OrcamentoView = () => import("@/views/loja/OrcamentoView.vue");
const PromocaoView = () => import("@/views/loja/PromocaoView.vue");
const ContasReceberView = () => import("@/views/loja/ContasReceberView.vue");
const InventarioView = () => import("@/views/loja/InventarioView.vue");
const EtiquetaView = () => import("@/views/loja/EtiquetaView.vue");
const ContaPagarView = () => import("@/views/loja/ContaPagarView.vue");
const EntregaView = () => import("@/views/loja/EntregaView.vue");
const FidelidadeView = () => import("@/views/loja/FidelidadeView.vue");
const PDVView = () => import("@/views/loja/PDVView.vue");
const NotificacoesView = () => import("@/views/NotificacoesView.vue");
const SetupLojaView = () => import("@/views/SetupLojaView.vue");

// Servicos / Agenda
const ServicoView = () => import("@/views/loja/ServicoView.vue");
const ProfissionalView = () => import("@/views/loja/ProfissionalView.vue");
const AgendaView = () => import("@/views/loja/AgendaView.vue");
const AgendamentosView = () => import("@/views/loja/AgendamentosView.vue");
const OrdensServicoView = () => import("@/views/loja/OrdensServicoView.vue");

// Pet
const BanhoTosaView = () => import("@/views/loja/BanhoTosaView.vue");
const RacoesView = () => import("@/views/loja/RacoesView.vue");
const PetView = () => import("@/views/loja/pet/PetView.vue");

// Restaurante
const CardapioView = () => import("@/views/loja/CardapioView.vue");
const MesasView = () => import("@/views/loja/MesasView.vue");
const SalaoView = () => import("@/views/loja/SalaoView.vue");
const CozinhaView = () => import("@/views/loja/CozinhaView.vue");

// Veterinaria
const ProntuariosView = () => import("@/views/loja/ProntuariosView.vue");
const ConsultasView = () => import("@/views/loja/ConsultasView.vue");

// Otica
const ReceituarioView = () => import("@/views/loja/otica/ReceituarioView.vue");
const ExameOptometriaView = () => import("@/views/loja/otica/ExameOptometriaView.vue");

// Fiscal / NFC-e
const NfceView = () => import("@/views/loja/NfceView.vue");
const ConfiguracaoFiscalView = () => import("@/views/admin/ConfiguracaoFiscalView.vue");
const CertificadosView = () => import("@/views/admin/CertificadosView.vue");

// Admin
const UsuarioView = () => import("@/views/admin/UsuarioView.vue");
const PerfilView = () => import("@/views/admin/PerfilView.vue");
const ConfiguracaoView = () => import("@/views/admin/ConfiguracaoView.vue");
const AuditoriaView = () => import("@/views/admin/AuditoriaView.vue");
const FuncionarioView = () => import("@/views/admin/FuncionarioView.vue");
const ComissaoView = () => import("@/views/admin/ComissaoView.vue");
const PermissaoView = () => import("@/views/admin/PermissaoView.vue");
const SegmentosView = () => import("@/views/admin/SegmentosView.vue");
const PlanosView = () => import("@/views/admin/PlanosView.vue");
const ConfiguracaoPixView = () => import("@/views/admin/ConfiguracaoPixView.vue");

const routes = [
  { path: "/", name: "Login", component: LoginView, meta: { requiresAuth: false, layout: "empty" } },
  { path: "/setup", name: "SetupLoja", component: SetupLojaView, meta: { requiresAuth: true, layout: "empty" } },
  { path: "/home", name: "Home", component: HomeView, meta: { requiresAuth: true, layout: "default" } },
  { path: "/dashboard-multi-loja", name: "DashboardMultiLoja", component: DashboardMultiLojaView, meta: { requiresAuth: true, layout: "default" } },
  { path: "/meu-perfil", name: "MeuPerfil", component: MeuPerfilView, meta: { requiresAuth: true, layout: "default" } },
  { path: "/lgpd", name: "Lgpd", component: LgpdView, meta: { requiresAuth: true, layout: "default" } },

  // Loja
  { path: "/categorias", name: "Categoria", component: CategoriaView, meta: { requiresAuth: true, layout: "default" } },
  { path: "/produtos", name: "Produto", component: ProdutoView, meta: { requiresAuth: true, layout: "default" } },
  { path: "/estoque", name: "Estoque", component: EstoqueView, meta: { requiresAuth: true, layout: "default" } },
  { path: "/caixa", name: "Caixa", component: CaixaView, meta: { requiresAuth: true, layout: "default", modulo: "/caixa" } },
  { path: "/vendas", name: "Venda", component: VendaView, meta: { requiresAuth: true, layout: "default" } },
  { path: "/cliente", name: "Cliente", component: ClienteView, meta: { requiresAuth: true, layout: "default" } },
  { path: "/fornecedores", name: "Fornecedor", component: FornecedorView, meta: { requiresAuth: true, layout: "default" } },
  { path: "/trocas", name: "Troca", component: TrocaView, meta: { requiresAuth: true, layout: "default", modulo: "/trocas" } },
  { path: "/orcamentos", name: "Orcamento", component: OrcamentoView, meta: { requiresAuth: true, layout: "default", modulo: "/orcamentos" } },
  { path: "/promocoes", name: "Promocao", component: PromocaoView, meta: { requiresAuth: true, layout: "default", modulo: "/promocoes" } },
  { path: "/contas-receber", name: "ContasReceber", component: ContasReceberView, meta: { requiresAuth: true, layout: "default", modulo: "/contas-receber" } },
  { path: "/inventario", name: "Inventario", component: InventarioView, meta: { requiresAuth: true, layout: "default", modulo: "/inventario" } },
  { path: "/etiquetas", name: "Etiqueta", component: EtiquetaView, meta: { requiresAuth: true, layout: "default", modulo: "/etiquetas" } },
  { path: "/importacao", name: "Importacao", component: ImportacaoView, meta: { requiresAuth: true, layout: "default", modulo: "/importacao" } },
  { path: "/relatorios", name: "Relatorio", component: RelatorioView, meta: { requiresAuth: true, layout: "default", modulo: "/relatorios" } },
  { path: "/contas-pagar", name: "ContaPagar", component: ContaPagarView, meta: { requiresAuth: true, layout: "default", modulo: "/contas-pagar" } },
  { path: "/entregas", name: "Entrega", component: EntregaView, meta: { requiresAuth: true, layout: "default", modulo: "/entregas" } },
  { path: "/fidelidade", name: "Fidelidade", component: FidelidadeView, meta: { requiresAuth: true, layout: "default", modulo: "/fidelidade" } },
  { path: "/pdv", name: "PDV", component: PDVView, meta: { requiresAuth: true, layout: "empty", modulo: "/pdv" } },
  { path: "/notificacoes", name: "Notificacoes", component: NotificacoesView, meta: { requiresAuth: true, layout: "default" } },

  // Servicos / Agenda
  { path: "/agenda", name: "Agenda", component: AgendaView, meta: { requiresAuth: true, layout: "default", modulo: "/agenda" } },
  { path: "/servicos", name: "Servico", component: ServicoView, meta: { requiresAuth: true, layout: "default", modulo: "/servicos" } },
  { path: "/profissionais", name: "Profissional", component: ProfissionalView, meta: { requiresAuth: true, layout: "default", modulo: "/profissionais" } },
  { path: "/agendamentos", name: "Agendamentos", component: AgendamentosView, meta: { requiresAuth: true, layout: "default", modulo: "/agendamentos" } },
  { path: "/ordens-servico", name: "OrdensServico", component: OrdensServicoView, meta: { requiresAuth: true, layout: "default", modulo: "/ordens-servico" } },

  // Pet
  { path: "/banho-tosa", name: "BanhoTosa", component: BanhoTosaView, meta: { requiresAuth: true, layout: "default", modulo: "/banho-tosa" } },
  { path: "/racoes", name: "Racoes", component: RacoesView, meta: { requiresAuth: true, layout: "default", modulo: "/racoes" } },
  { path: "/pets", name: "Pet", component: PetView, meta: { requiresAuth: true, layout: "default", modulo: "/pets" } },

  // Restaurante
  { path: "/cardapio", name: "Cardapio", component: CardapioView, meta: { requiresAuth: true, layout: "default", modulo: "/cardapio" } },
  { path: "/mesas", name: "Mesas", component: MesasView, meta: { requiresAuth: true, layout: "default", modulo: "/mesas" } },
  { path: "/salao", name: "Salao", component: SalaoView, meta: { requiresAuth: true, layout: "empty", modulo: "/salao" } },
  { path: "/cozinha", name: "Cozinha", component: CozinhaView, meta: { requiresAuth: true, layout: "empty", modulo: "/cozinha" } },

  // Veterinaria
  { path: "/prontuarios", name: "Prontuarios", component: ProntuariosView, meta: { requiresAuth: true, layout: "default", modulo: "/prontuarios" } },
  { path: "/consultas", name: "Consultas", component: ConsultasView, meta: { requiresAuth: true, layout: "default", modulo: "/consultas" } },

  // Otica
  { path: "/receituarios", name: "Receituario", component: ReceituarioView, meta: { requiresAuth: true, layout: "default", modulo: "/receituarios" } },
  { path: "/exames-optometria", name: "ExameOptometria", component: ExameOptometriaView, meta: { requiresAuth: true, layout: "default", modulo: "/exames-optometria" } },

  // Admin
  { path: "/usuarios", name: "Usuario", component: UsuarioView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },
  { path: "/perfis", name: "Perfil", component: PerfilView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },
  { path: "/configuracoes", name: "Configuracao", component: ConfiguracaoView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },
  { path: "/auditoria", name: "Auditoria", component: AuditoriaView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },
  { path: "/funcionarios", name: "Funcionario", component: FuncionarioView, meta: { requiresAuth: true, layout: "default", modulo: "/funcionarios" } },
  { path: "/comissoes", name: "Comissao", component: ComissaoView, meta: { requiresAuth: true, layout: "default", modulo: "/comissoes" } },
  { path: "/permissoes", name: "Permissao", component: PermissaoView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },
  { path: "/segmentos", name: "Segmentos", component: SegmentosView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },
  { path: "/planos", name: "Planos", component: PlanosView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },

  // Fiscal / NFC-e
  { path: "/nfce", name: "Nfce", component: NfceView, meta: { requiresAuth: true, layout: "default", modulo: "/nfce" } },
  { path: "/configuracao-fiscal", name: "ConfiguracaoFiscal", component: ConfiguracaoFiscalView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },
  { path: "/certificados", name: "Certificados", component: CertificadosView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },
  { path: "/configuracao-pix", name: "ConfiguracaoPix", component: ConfiguracaoPixView, meta: { requiresAuth: true, adminOnly: true, layout: "default" } },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { layout: 'empty' }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

let authCheckPromise: Promise<void> | null = null

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth) {
    if (!authStore.token && !sessionStorage.getItem("token")) {
      next({ name: "Login" });
      return;
    }

    if (!authStore.isAuthenticated) {
      if (!authCheckPromise) {
        authCheckPromise = authStore.checkAuth().finally(() => { authCheckPromise = null })
      }
      await authCheckPromise
    }

    if (!authStore.isAuthenticated) {
      next({ name: "Login" });
      return;
    }

    // Redirect to setup if no loja configured (admin pula direto para Home)
    if (to.name !== 'SetupLoja' && !authStore.lojaId && !authStore.isAdmin) {
      next({ name: 'SetupLoja' });
      return;
    }

    // Admin sem loja vai direto para Home (nunca mostra setup)
    if (to.name === 'SetupLoja' && authStore.isAdmin) {
      next({ name: 'Home' });
      return;
    }

    // Check admin-only routes.
    // Usa authStore.isAdmin (comparacao exata, case-insensitive, sobre o array de roles).
    // A versao anterior lia a string JSON crua de sessionStorage e chamava String.includes,
    // ou seja, fazia match de SUBSTRING: qualquer perfil contendo "Admin" no nome
    // (ex.: "Administrativo", "Admin Loja") passava no guard.
    if (to.meta.adminOnly && !authStore.isAdmin) {
      next({ name: 'Home' })
      return
    }

    // Check modulo access
    const modulo = to.meta.modulo as string | undefined;
    if (modulo) {
      const modulosVisiveis = authStore.modulosVisiveis || [];
      if (modulosVisiveis.length > 0 && !modulosVisiveis.includes(modulo)) {
        next({ name: 'Home' });
        return;
      }
    }

    next();
  } else {
    next();
  }
});

export default router;
